module.exports = __webpack_public_path__ + "static/media/features-interactive-color.ad2a79d5.png";